<svg
  xmlns="http://www.w3.org/2000/svg"
  id="svg-source"
  style="position: fixed; width: 0; height: 0"
>
  <symbol id="i2g-notification-success-icon" viewBox="0 0 16 16">
    <g id="Messaging" stroke="none" stroke-width="1" fill="none">
      <g
        id="Messaging-/-x_overrides-/-Status-Success"
        transform="translate(-8.000000, -24.000000)"
      >
        <g
          id="icon/Message/Success16"
          transform="translate(8.000000, 24.000000)"
        >
          <rect id="bounding-box" x="0" y="0" width="16" height="16"></rect>
          <g id="iconSuccess">
            <path
              d="M8,16 C12.418278,16 16,12.418278 16,8 C16,3.581722 12.418278,0 8,0 C3.581722,0 0,3.581722 0,8 C0,12.418278 3.581722,16 8,16 Z"
              id="Background"
              fill="#FFFFFF"
            ></path>
            <polygon
              id="Combined-Shape"
              fill="#22A971"
              points="6.2010256 9.8382602 10.9282516 3.78768687 12.2170334 4.78539998 6.35597141 12.2778604 6.35288112 12.2716116 6.35352188 12.2927621 3.2 9.14373677 4.32429297 7.96152756"
            ></polygon>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="i2g-notification-info-icon" viewBox="0 0 16 16">
    <g
      id="Messaging"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Messaging-/-x_overrides-/-Status-Information"
        transform="translate(-8.000000, -24.000000)"
      >
        <g id="icon/Message/Info16" transform="translate(8.000000, 24.000000)">
          <rect id="bounding-box" x="0" y="0" width="16" height="16"></rect>
          <g id="iconInformation">
            <circle id="Background" fill="#FFFFFF" cx="8" cy="8" r="8"></circle>
            <rect
              id="stroke"
              fill="#0875E2"
              x="7"
              y="7"
              width="2"
              height="6"
            ></rect>
            <rect
              id="Dot"
              fill="#0875E2"
              x="7"
              y="3"
              width="2"
              height="2"
            ></rect>
          </g>
        </g>
      </g>
    </g>
  </symbol>

  <symbol id="i2g-notification-alert-icon" viewBox="0 0 16 16">
    <g
      id="icon/Message/Alert16"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <rect id="bounding-box" x="0" y="0" width="16" height="16"></rect>
      <g id="iconAlert">
        <circle id="Background" fill="#FFFFFF" cx="8" cy="8" r="8"></circle>
        <rect
          id="Stroke"
          fill="#E80E51"
          x="7"
          y="3"
          width="2"
          height="6"
        ></rect>
        <polygon id="Dot" fill="#E80E51" points="7 11 9 11 9 13 7 13"></polygon>
      </g>
    </g>
  </symbol>

  <symbol id="dismiss-icon" viewBox="0 0 10 10">
    <g id="Messaging" stroke="none" stroke-width="1" fill="none">
      <g
        id="Messaging-/-x_overrides-/-Panel"
        transform="translate(-679.000000, -27.000000)"
      >
        <g
          id="icons-/-UI-/-Close-Sm"
          transform="translate(672.000000, 20.000000)"
        >
          <rect id="Bounding-box" x="0" y="0" width="24" height="24"></rect>
          <mask id="mask-2" fill="white">
            <path
              d="M7.97618265,7.16747665 L12,11.191 L16.0238174,7.16747665 C16.2471196,6.94417445 16.609164,6.94417445 16.8324662,7.16747665 C17.0557684,7.39077886 17.0557684,7.75282326 16.8324662,7.97612547 L12.809,12 L16.8325233,16.0238174 C17.0558256,16.2471196 17.0558256,16.609164 16.8325233,16.8324662 C16.6092211,17.0557684 16.2471767,17.0557684 16.0238745,16.8324662 L12,12.809 L7.97612547,16.8324662 C7.75282326,17.0557684 7.39077886,17.0557684 7.16747665,16.8324662 C6.94417445,16.609164 6.94417445,16.2471196 7.16747665,16.0238174 L11.191,12 L7.16753383,7.97612547 C6.94423163,7.75282326 6.94423163,7.39077886 7.16753383,7.16747665 C7.39083604,6.94417445 7.75288044,6.94417445 7.97618265,7.16747665 Z"
            ></path>
          </mask>
          <path
            d="M7.97618265,7.16747665 L12,11.191 L16.0238174,7.16747665 C16.2471196,6.94417445 16.609164,6.94417445 16.8324662,7.16747665 C17.0557684,7.39077886 17.0557684,7.75282326 16.8324662,7.97612547 L12.809,12 L16.8325233,16.0238174 C17.0558256,16.2471196 17.0558256,16.609164 16.8325233,16.8324662 C16.6092211,17.0557684 16.2471767,17.0557684 16.0238745,16.8324662 L12,12.809 L7.97612547,16.8324662 C7.75282326,17.0557684 7.39077886,17.0557684 7.16747665,16.8324662 C6.94417445,16.609164 6.94417445,16.2471196 7.16747665,16.0238174 L11.191,12 L7.16753383,7.97612547 C6.94423163,7.75282326 6.94423163,7.39077886 7.16753383,7.16747665 C7.39083604,6.94417445 7.75288044,6.94417445 7.97618265,7.16747665 Z"
            fill="#162D3D"
          ></path>
        </g>
      </g>
    </g>
  </symbol>
</svg>

<div class="content-wrapper">
  <div class="icon-container" [ngClass]="notificationStyle">
    <i2g-icon
      class="notification-icon"
      [name]="'i2g-notification-' + NotificationIconsEnum[notificationStyle]"
      size="custom"
    >
    </i2g-icon>
  </div>

  <p
    *ngIf="isHtmlMessage; else textMessage"
    class="message"
    [innerHTML]="message | safe: 'html'"
  ></p>

  &ensp;

  <ng-template #textMessage>
    <p *ngIf="!isHtmlMessage" class="message">
      {{ message }}
      <span
        *ngIf="showButton"
        class="button-text"
        (click)="clickButton.emit()"
        i2gTrackable
        [trackingObject]="trackingObject"
        [trackingAction]="buttonTrackingAction"
        >{{ buttonText }}</span
      >
    </p>
  </ng-template>

  <button
    *ngIf="showDismissIcon"
    class="dismiss-icon-container"
    (click)="dismiss.emit()"
    i2gTrackable
    [trackingObject]="trackingObject"
    [trackingAction]="dismissTrackingAction"
  >
    <i2g-icon class="dismiss-icon" name="dismiss" size="custom"> </i2g-icon>
  </button>
</div>
